import catchify from 'catchify';
import { SMART_COLLECTIONS_URL } from '@/constants/api';
import { formatConditions } from '~/util/collections';

export const getCollections = async ($cachios) => {
  const [err, collections] = await catchify($cachios.get(`${SMART_COLLECTIONS_URL}/?format=json&per_page=999&exclude[]=*&include[]=slug&include[]=is_dynamic_collection&include[]=root_level`));

  if (err || !collections || !collections.data || !collections.data.smart_collections) {
    return [];
  }

  return collections.data.smart_collections;
};

export const getCollectionZones = async ($cachios, zones, conditions, templateSlug) => {
  let url = `/api/smartcollections/zone/?zones=${zones.join(',')}`;
  if (templateSlug) {
    url += `&template_slug=${templateSlug}`;
  }
  if (conditions) {
    url += `&conditions=${formatConditions(conditions)}`;
  }
  const [err, ret] = await catchify($cachios.get(url));

  if (err || !ret || !ret.data) {
    return {};
  }

  return ret.data;
};

export default {
  getCollections,
  getCollectionZones,
};
